<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="title">仓位体验券数据统计</div>
      <filters
        :filters="filters"
        position
        :export-loading="exportLoading"
        @search="search"
        @reset="reset"
        @export="download('仓位体验券数据统计')"
      />
      <div class="summary" v-loading="summaryLoading">
        <div class="summary-item">
          <span>总领取金额：</span
          ><strong>{{ amount(summary.totalReceiveAmount) }} USDT</strong>
        </div>
        <div class="summary-item">
          <span>总回收金额：</span
          ><strong>{{ amount(summary.totalRecycleAmount) }} USDT</strong>
        </div>
        <div class="summary-item">
          <span>总亏损金额：</span
          ><strong>{{ amount(summary.totalLossAmount) }} USDT</strong>
        </div>
        <div class="summary-item">
          <span>总盈利金额：</span
          ><strong>{{ amount(summary.totalProfitAmount) }} USDT</strong>
        </div>
      </div>
      <el-table
        :data="rows"
        size="mini"
        v-loading="loading"
        height="calc(100vh - 350px)"
        ><el-table-column
          prop="userUid"
          label="用户UID"
          min-width="110"
        /><el-table-column
          prop="userTypeDesc"
          label="用户类型"
          min-width="100"
        /><el-table-column label="合伙人UID" min-width="110"
          ><template slot-scope="s">{{
            display(s.row.partnerUid)
          }}</template></el-table-column
        ><el-table-column prop="couponNo" label="卡券ID" min-width="180" />
        <el-table-column label="领取金额" min-width="110"
          ><template slot-scope="s">{{
            amount(s.row.receiveAmount)
          }}</template></el-table-column
        ><el-table-column label="回收金额" min-width="110"
          ><template slot-scope="s">{{
            amount(s.row.recycleAmount)
          }}</template></el-table-column
        ><el-table-column label="亏损金额" min-width="110"
          ><template slot-scope="s">{{
            amount(s.row.lossAmount)
          }}</template></el-table-column
        ><el-table-column label="盈利金额" min-width="110"
          ><template slot-scope="s">{{
            amount(s.row.profitAmount)
          }}</template></el-table-column
        ><el-table-column
          prop="coin"
          label="币种"
          min-width="80"
        /><el-table-column label="使用时间" min-width="160"
          ><template slot-scope="s">{{
            time(s.row.useTime)
          }}</template></el-table-column
        ><el-table-column label="开仓时间" min-width="160"
          ><template slot-scope="s">{{
            time(s.row.openTime)
          }}</template></el-table-column
        ><el-table-column label="平仓时间" min-width="160"
          ><template slot-scope="s">{{
            time(s.row.closeTime)
          }}</template></el-table-column
        >
        <el-table-column label="平仓状态" min-width="160" fixed="right">
          <template slot="header">
            <el-tooltip content="展示仓位当前平仓及结算状态，覆盖手动与系统平仓" placement="top">
              <span>平仓状态 <i class="el-icon-info" /></span>
            </el-tooltip>
          </template>
          <template slot-scope="scope"><manual-operation :row="scope.row" closing display="status" /></template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope"><manual-operation :row="scope.row" closing @refresh="fetchAll" /></template>
        </el-table-column>
      </el-table>
      <div class="pag">
        <pagination
          :size="pagination.size"
          :total="total"
          :page="pagination.page"
          @pageChanged="pageChanged"
        />
      </div>
    </el-card>
  </div>
</template>
<script>
import Pagination from "components/pagination";
import Filters from "../CouponStatistic/Filters";
import mixin from "../CouponStatistic/mixin";
import api from "../CouponStatistic/api";
import ManualOperation from "../components/ManualOperation";
export default {
  name: "WelfarePositionStatistic",
  components: { Pagination, Filters, ManualOperation },
  mixins: [mixin],
  data: () => ({
    kind: "position", summary: {}, summaryLoading: false,
    pollTimer: null, pollingActive: true, listRequestId: 0, summaryRequestId: 0,
  }),
  created() {
    this.fetchAll();
  },
  activated() {
    if (!this.pollingActive) {
      this.pollingActive = true;
      this.fetchAll();
    }
  },
  deactivated() {
    this.stopPolling();
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    stopPolling() {
      this.pollingActive = false;
      this.clearPollTimer();
      // 离开页面后丢弃在途响应，避免旧响应重新启动轮询。
      this.listRequestId++;
      this.summaryRequestId++;
    },
    clearPollTimer() {
      if (this.pollTimer !== null) clearTimeout(this.pollTimer);
      this.pollTimer = null;
    },
    schedulePoll() {
      this.clearPollTimer();
      if (!this.pollingActive || this.loading ||
          !this.rows.some((row) => ["PROCESSING", "SETTLING"].includes(row.closeStatus))) return;
      this.pollTimer = setTimeout(() => {
        this.pollTimer = null;
        this.fetchAll(true);
      }, 3000);
    },
    fetchList(quiet = false) {
      if (!this.pollingActive || !this.valid()) return;
      this.clearPollTimer();
      const requestId = ++this.listRequestId;
      this.loading = true;
      return api.list(this.kind, this.query()).then((res) => {
        if (!res || res.code !== 0) throw new Error((res && res.msg) || "查询失败");
        if (!this.pollingActive || requestId !== this.listRequestId) return;
        const data = res.data || {};
        this.rows = data.items || [];
        this.total = Number(data.total || 0);
      }).catch((error) => {
        if (!this.pollingActive || requestId !== this.listRequestId) return;
        // 自动查询失败保留原状态，下一轮继续核对，不推断平仓失败。
        if (quiet !== true) {
          this.rows = [];
          this.total = 0;
          this.$message.error(error.message || "查询失败");
        }
      }).finally(() => {
        if (requestId !== this.listRequestId) return;
        this.loading = false;
        this.schedulePoll();
      });
    },
    fetchAll(quiet = false) {
      if (!this.pollingActive) return;
      if (!this.valid()) return;
      this.fetchList(quiet);
      const requestId = ++this.summaryRequestId;
      this.summaryLoading = true;
      api
        .summary(this.kind, this.query(false))
        .then((r) => {
          if (!this.pollingActive || requestId !== this.summaryRequestId) return;
          if (!r || r.code !== 0)
            throw new Error((r && r.msg) || "汇总查询失败");
          this.summary = r.data || {};
        })
        .catch((e) => {
          if (!this.pollingActive || requestId !== this.summaryRequestId) return;
          if (quiet !== true) {
            this.summary = {};
            this.$message.error(e.message);
          }
        })
        .finally(() => {
          if (requestId !== this.summaryRequestId) return;
          this.summaryLoading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.title {
  margin-bottom: 18px;
  color: #409eff;
  font-size: 16px;
}
.summary {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 36px;
  min-height: 25px;
  margin-bottom: 16px;
  font-size: 13px;
}
.summary-item {
  min-width: 200px;
}
.summary-item strong {
  color: #e6a23c;
  font-weight: normal;
}
.pag {
  display: flex;
  justify-content: center;
}
</style>
